import React from 'react';
import { SaveObjectPanel } from '../../../../../Components/SaveObjectPanel/SaveObjectPanel';
import { ItemListConfig, ItemValueType } from '../../../../../Models';
import { ItemForm } from '../ItemForm/ItemForm';
import {
  ItemListSection,
  ItemListSectionMessage
} from '../ItemListSection/ItemListSection';
import { UserGroup } from 'ui-smartforce-settings';
import { useItemListFormView } from './Hooks/useItemListformView';
import { ItemMissingInformationContext } from '../ContactFormView';

export const UserGroupsContext = React.createContext<UserGroup[]>([]);
export interface ItemListFormProps {
  name: string;
  className?: string;
  config: ItemListConfig;
  itemLabel: string;
  itemListValue: ItemValueType[];
  disabled?: boolean;
  message?: ItemListSectionMessage;
  showStateMandated?: boolean;
  onChange: (itemListValue: ItemValueType[], index?: number) => void;
}

export const ItemListForm = ({
  name,
  className,
  config,
  itemLabel,
  itemListValue,
  disabled = false,
  message,
  showStateMandated = false,
  onChange
}: ItemListFormProps): React.ReactElement<ItemListFormProps> => {
  const {
    isPanelOpen,
    value,
    selected,
    groups,
    isSaveDisabled,
    isItemMissingInformation,
    onAdd,
    onSelect,
    onDuplicate,
    onRemove,
    onSave,
    onClosePanel,
    onItemFormChange,
    onNeedHelp
  } = useItemListFormView({
    config,
    itemListValue,
    sectionName: name,
    onChange
  });

  return (
    <React.Fragment>
      <SaveObjectPanel
        title={`${itemLabel} ${
          selected === -1 ? itemListValue.length + 1 : selected + 1
        }`}
        isOpen={isPanelOpen}
        isSaveDisabled={isSaveDisabled}
        saveBtnLabel={selected !== -1 ? 'Save Changes' : `Add ${itemLabel}`}
        onClose={onClosePanel}
        onSave={onSave}
        onNeedHelp={onNeedHelp}
      >
        <UserGroupsContext.Provider value={groups}>
          <ItemMissingInformationContext.Provider
            value={isItemMissingInformation}
          >
            <ItemForm
              sectionName={name}
              config={config}
              value={value}
              onChange={onItemFormChange}
            />
          </ItemMissingInformationContext.Provider>
        </UserGroupsContext.Provider>
      </SaveObjectPanel>

      <ItemListSection
        className={className}
        title={config.title}
        items={itemListValue}
        config={config}
        itemLabel={itemLabel}
        onAdd={onAdd}
        onSelect={onSelect}
        onDuplicate={onDuplicate}
        onRemove={onRemove}
        disabled={disabled}
        message={message}
        showStateMandated={showStateMandated}
      />
    </React.Fragment>
  );
};
